import { RefreshCw } from 'lucide-react'
import { useProductData } from '../data'
import { formatTimestamp } from '../utils'

export function DataStatusPage() {
  const { data, internalProductInfo } = useProductData()
  if (!data || !internalProductInfo) return null
  const totalProducts = data.meta.productCounts.spu + data.meta.productCounts.sku
  const coverage = totalProducts ? data.meta.productImageCount / totalProducts * 100 : 0
  return (
    <div className="page-stack data-status-page">
      <div className="page-title-row">
        <div><h1>数据状态</h1><p>网站只读展示本地仓库中的京东经营数据。</p></div>
        <button type="button" className="refresh-button" onClick={() => window.location.reload()}><RefreshCw aria-hidden="true" />重新载入</button>
      </div>
      <section className="status-band">
        <div><span>业务日期</span><strong>{data.meta.minDate} 至 {data.meta.maxDate}</strong></div>
        <div><span>数据运行</span><strong>{data.meta.runId}</strong></div>
        <div><span>网站数据生成</span><strong>{formatTimestamp(data.generatedAt)}</strong></div>
        <div><span>采集时间</span><strong>{data.meta.collectedAt}</strong></div>
      </section>
      <section className="status-section">
        <h2>商品覆盖</h2>
        <div className="definition-grid">
          <div><span>历史SPU</span><strong>{data.meta.productCounts.spu.toLocaleString('zh-CN')}</strong></div>
          <div><span>历史SKU</span><strong>{data.meta.productCounts.sku.toLocaleString('zh-CN')}</strong></div>
          <div><span>官方映射SPU</span><strong>{data.meta.mappedCounts.spu.toLocaleString('zh-CN')}</strong></div>
          <div><span>官方映射SKU</span><strong>{data.meta.mappedCounts.sku.toLocaleString('zh-CN')}</strong></div>
          <div><span>网站有图商品</span><strong>{data.meta.productImageCount.toLocaleString('zh-CN')} / {totalProducts.toLocaleString('zh-CN')}</strong></div>
          <div><span>网站图片覆盖</span><strong>{coverage.toFixed(2)}%</strong></div>
        </div>
      </section>
      <section className="status-section">
        <h2>来源文件</h2>
        <div className="table-responsive"><table className="source-table"><thead><tr><th>页面</th><th>查询窗口</th><th>粒度</th><th>文件</th><th>SHA256</th></tr></thead><tbody>{data.sources.map((source) => <tr key={`${source.sourceFile}:${source.queryStart}`}><td>{source.pageId}</td><td>{source.queryStart} 至 {source.queryEnd}</td><td>{source.granularity}</td><td>{source.sourceFile}</td><td><code>{source.sha256.slice(0, 12)}</code></td></tr>)}</tbody></table></div>
      </section>
      <section className="status-section">
        <h2>公司产品资料</h2>
        <div className="definition-grid">
          <div><span>源表记录</span><strong>{internalProductInfo.summary.records.toLocaleString('zh-CN')}</strong></div>
          <div><span>唯一产品编码</span><strong>{internalProductInfo.summary.uniqueProductCodes.toLocaleString('zh-CN')}</strong></div>
          <div><span>缺少产品编码</span><strong>{internalProductInfo.summary.recordsWithoutProductCode.toLocaleString('zh-CN')}</strong></div>
          <div><span>重复产品编码</span><strong>{internalProductInfo.summary.duplicateProductCodes.toLocaleString('zh-CN')}</strong></div>
        </div>
        <p className="status-source-note">来源：{internalProductInfo.source.file}；SHA256：<code>{internalProductInfo.source.sha256}</code></p>
      </section>
      <section className="status-section"><h2>口径</h2><p>{data.meta.attribution}。SPU图片是官方SPU→SKU映射下的代表SKU图；无官方映射时不按名称猜图。</p></section>
    </div>
  )
}
